export const getCampaignNameFromLink = (link?: string, t?: any) => {
  if (!link) return t('subscribers.campaign.unknown');

  try {
    const url = new URL(link);
    const cleanedPath = url.pathname.replace(/\/+$/, '');
    const segments = cleanedPath.split('/').filter(Boolean);
    const linkSuffix = segments[segments.length - 1];

    if (segments.length) return  linkSuffix?.length > 5 ? linkSuffix?.slice(-4) : linkSuffix;
    return url.hostname?.length > 5 ? url.hostname?.slice(-4) : url.hostname;
  } catch {
    const cleanedLink = link.replace(/\/+$/, '');
    const parts = cleanedLink.split('/').filter(Boolean);
    const linkSuffix = parts[parts.length - 1];
    return parts.length ? linkSuffix?.length > 5 ? linkSuffix?.slice(-4) : linkSuffix : link;
  }
};
